import http from "@/common/axios";
import { Review } from "@/types";

export default class ReviewService {
  async getLatestReview(): Promise<Review> {
    const response = await http.get(`reviews/self/latest`);
    return response.data;
  }
}
